/* eslint-disable no-param-reassign, no-unused-vars, no-restricted-syntax, import/no-cycle */
import { useCallback } from 'react';
import moment from 'moment';
import { INVOICE_SERVICE } from '../../../constant/invoice';
import resourceSlug from '../../../constant/resource-slug';
import { hasPermission, isSystemUsers } from '../../../services/util/auth';
import { sanitizeRoyalty } from '../../brand/components/utils';

export const useHasCreateInvoicePermission = () => {
  const isSU = isSystemUsers();
  const hasCreatePermission = hasPermission(resourceSlug.INVOICE, 'create');

  return hasCreatePermission && isSU;
};

export const useHasReadInvoicePermission = () => {
  const hasReadPermission = hasPermission(resourceSlug.INVOICE, 'read');

  return hasReadPermission;
};

export const useHasReadCurrencyPermission = () => hasPermission(resourceSlug.CURRENCY, 'list');

export const useTransformGroupData = () => {
  const hasCreateInvoicePermission = useHasCreateInvoicePermission();

  return useCallback(
    (data, isEdit) => {
      const {
        features,
        monthlyRoyalty,
        mktRoyalty,
        companyAddress,
        group,
        invoiceProfile,
        openingBalanceStartTime,
        ...otherData
      } = data || {};

      const refactorData = removeAddressLines(otherData, 'companyAddress');

      return {
        ...refactorData,
        invoiceProfile: hasCreateInvoicePermission
          ? {
              ...removeAddressLines(invoiceProfile),
              ...(companyAddress || []).reduce((list, addressLine, index) => {
                if (addressLine) {
                  list[`addressLine${index + 1}`] = addressLine;
                }
                return list;
              }, {}),
            }
          : undefined,
        disableBrands: !otherData.enabled && isEdit ? true : undefined,
        openingBalanceTime: openingBalanceStartTime
          ? moment(openingBalanceStartTime).startOf('month').unix()
          : openingBalanceStartTime,
        featureIds: features?.map?.((feature) => feature?.id || feature),
        royalty: hasCreateInvoicePermission
          ? sanitizeRoyalty([
              {
                invoiceService: INVOICE_SERVICE.MONTHLY_GGR,
                value: monthlyRoyalty,
              },
              {
                invoiceService: INVOICE_SERVICE.MKT_FREE_SPIN,
                value: mktRoyalty,
              },
            ])
          : undefined,
      };
    },
    [hasCreateInvoicePermission],
  );
};

const removeAddressLines = (obj, addressKey = 'addressLine') => {
  const cloneObj = {
    ...obj,
  };
  for (const key in cloneObj) {
    if (key.startsWith(addressKey)) {
      delete cloneObj[key];
    }
  }
  return cloneObj;
};
